/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import can from 'can';
import BaseWidget from 'scripts/base-widget';
import 'components/video-landing/video-landing';

export const VideoLanding = BaseWidget.extend({
    init: function () {
        this.viewModel = {
            products: this.options.products,
            productsCtaLink: this.options.productsCtaLink,
            tabs: new can.List(this.options.tabs || []),
            sponsor: this.options.sponsor ? this.options.sponsor : null,
            streamOffMessagingConfig: {
                videoStreamingOn: this.options.streamOffMessagingConfig.videoStreamingOn,
                titleText: this.options.streamOffMessagingConfig.titleText,
                streamNotAvailableMessage: this.options.streamOffMessagingConfig.streamNotAvailableMessage,
                streamNotAvailableImagePath: this.options.streamOffMessagingConfig.streamNotAvailableImagePath
            },
            sidebar: {
                tabs: new can.List(this.options.sidebar.tabs),
                groups: new can.List(this.options.sidebar.groups),
                sponsor: new can.Map(this.options.sidebar.sponsor)
            },
            livePageAdUnit: new can.Map(this.options.livePageAdUnit),
            liveMultilineVideoPlayerPageUrl: this.options.liveMultilineVideoPlayerPageUrl,
            backgroundImage: this.options.backgroundImage ? this.options.backgroundImage : null,
        };
        this.view = can.stache(`
            <video-landing 
                {tabs}="tabs" 
                {sidebar}="sidebar" 
                {live-page-ad-unit}="livePageAdUnit" 
                {stream-off-messaging-config}="streamOffMessagingConfig" 
                {live-multiline-video-player-page-url}="liveMultilineVideoPlayerPageUrl" 
                {products}="products"
                {products-cta-link}="productsCtaLink"
                {background-image}="backgroundImage"
            />`);
        this._super();
    },
});
